import { ContextMenuMESFProvider } from "../../../controls/contextMenu/useContextMenuMESF";
import { CategoriesProvider } from "../../delays/categories/context/CategoriesContext";
import { ConfigurationDelayCodeProvider } from "../../delays/codes/context/ConfigurationDelayCodeContext";
import { DelaysManagerPage } from "./DelaysManagerPage";
import { DelaysManagerProvider } from "./context/DelaysManagerContext";

type Props = {
	asset: "caster" | "eaf";
};
const DelaysManager = ({ asset }: Props) => {
	return (
		<ContextMenuMESFProvider>
			<ConfigurationDelayCodeProvider>
				<CategoriesProvider>
					<DelaysManagerProvider>
						<DelaysManagerPage asset={asset} />
					</DelaysManagerProvider>
				</CategoriesProvider>
			</ConfigurationDelayCodeProvider>
		</ContextMenuMESFProvider>
	);
};
export default DelaysManager;
